import { z } from "zod";

export const dateSchema = z.preprocess((arg) => {
  // Dates look like "2023-08-24T13:13:12.614Z"
  if (typeof arg === "string") {
    return new Date(arg);
  } else {
    return undefined;
  }
}, z.date());
